// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import IsUngatedStore from 'crm_data/gates/IsUngatedStore';
import { gate } from 'hub-http/gates';
const isUngatedForDeprecateLegacyTimelineDependency = {
  stores: [IsUngatedStore],
  deref: () => IsUngatedStore.get(gate('CRM:Events:DeprecateLegacyTimeline'))
};
export default isUngatedForDeprecateLegacyTimelineDependency;